module.exports = __webpack_public_path__ + "static/media/view-scheduler.4df7af75.svg";